import Modal from "./Modal";
import assetPath from "../../utils/assetPath";
import { Trash2 } from "lucide-react";

const imgWarningIcon = assetPath("/icons/warning-icon.svg");

interface DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: React.ReactNode;
  confirmLabel: string;
  cancelLabel: string;
}

const DeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  cancelLabel,
}: DeleteModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div
        className="w-full bg-white rounded-[8px] p-[33px] flex flex-col items-center border border-[rgba(194,199,201,0.2)]"
        style={{ boxShadow: "0px 25px 50px -12px rgba(0,0,0,0.25)" }}
      >
        {/* Warning icon */}
        <div
          className="w-16 h-16 rounded-[12px] flex items-center justify-center mb-6"
          style={{ backgroundColor: "rgba(255,218,214,0.3)" }}
        >
          <img src={imgWarningIcon} alt="" className="w-[27.5px] h-[23.75px]" />
        </div>

        {/* Title */}
        <h2
          className="text-[22px] font-bold text-center mb-3 leading-snug text-content-heading"
        >
          {title}
        </h2>

        {/* Message */}
        <div
          className="text-[16px] font-medium text-center mb-8 leading-[26px] text-content-label"
        >
          {message}
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-3 w-full">
          <button
            type="button"
            onClick={onConfirm}
            className="w-full flex items-center justify-center gap-2 py-[14px] rounded-[4px] text-white text-[16px] font-bold transition-opacity hover:opacity-90"
            style={{
              backgroundColor: "#ba1a1a",
              boxShadow: "0px 10px 15px -3px rgba(186,26,26,0.2), 0px 4px 6px -4px rgba(186,26,26,0.2)",
            }}
          >
            <Trash2 className="w-[13px] h-[15px] text-white" />
            {confirmLabel}
          </button>

          <button
            type="button"
            onClick={onClose}
            className="w-full py-[14px] rounded-[4px] text-[16px] font-bold transition-opacity hover:opacity-80 text-content-body"
          style={{ backgroundColor: "#e9e9df" }}
          >
            {cancelLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
